import SearchKeyword from "@grindex-client/components/Search/Extensions/search-keyword.class";
import { FacetsManager } from "@grindex-client/components/Search/Extensions/facets-search.class";
import SearchHeader from "@grindex-client/components/Search/Extensions/SearchHeader.class";
import EventManager from "@grindex-common/helpers/EventManager.class";
import DirtyManager from "@grindex-client/components/Search/Extensions/DirtyManager.class";
import CommonQuery from "@grindex-client/components/Search/Query/common-query.class";
import { xylemStorage } from "@grindex-client/components/SessionStorage/xylemStorage";
import { events } from "@grindex-common/helpers/events";

class CommonSearch extends SearchKeyword {
	facetsManager: FacetsManager<CommonQuery>;
	searchHeader: SearchHeader;
	constructor($ownerModule: HTMLElement) {
		const eventManager = new EventManager();
		const dirtyManager = new DirtyManager();
		const query = new CommonQuery();

		super($ownerModule, eventManager, dirtyManager, query);

		this.facetsManager = new FacetsManager($ownerModule, eventManager, dirtyManager, query);
		this.searchHeader = new SearchHeader($ownerModule, eventManager, query);

		this.facetsManager.initFacets();
		this.getStoreData();

		this.searchHeader.initHeader(this.queryObject.getPagingData().pageSize);

		this.$module = $ownerModule;

		this.eventManager.on(this, events.search.CHANGE_PAGE_SIZE, this.onPageSizeChanged.bind(this));
		this.eventManager.on(this, events.search.RENDERED, this.facetsManager.renderCurrentFilters.bind(this.facetsManager));
	}

	getStoreData() {
		const storedData = xylemStorage.getCurrentSessionStorage(xylemStorage.applicationDetail.storageName);

		if (storedData.length > 0 && !this.queryObject.queryData.facetids.includes(storedData)) {
			this.queryObject.queryData.facetids.push(storedData);
		}
	}

	onPageSizeChanged() {
		this.search();
	}
}

export default CommonSearch;
